import { useContext, createContext, useMemo } from 'react';
import { getHeaders } from '../utils';
import { useUserSegmentationData } from './userSegmentationDataContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const HeadersContext = /*#__PURE__*/createContext({
  loading: true,
  headers: {}
});
export const HeadersProvider = ({
  children,
  atpClusterId: atpClusterIdParam,
  customerId,
  customerTypeId: customerTypeIdParam,
  language,
  skipUserSegmentationFetching,
  sourceAppName,
  tenant,
  token,
  useProductDataCaching,
  useProductsService,
  visitorSegment: visitorSegmentParam
}) => {
  const userSegmentationData = useUserSegmentationData();
  const atpClusterId = userSegmentationData.atpClusterId ?? atpClusterIdParam;
  const customerTypeId = userSegmentationData.customerTypeId ?? customerTypeIdParam;
  const visitorSegment = userSegmentationData.visitorSegment ?? visitorSegmentParam;
  const value = useMemo(() => ({
    headers: getHeaders({
      atpClusterId,
      customerId,
      customerTypeId,
      language,
      sourceAppName,
      tenant,
      token,
      useProductDataCaching,
      useProductsService,
      visitorSegment
    }),
    loading: !skipUserSegmentationFetching && userSegmentationData.loading
  }), [atpClusterId, customerId, customerTypeId, language, skipUserSegmentationFetching, sourceAppName, tenant, token, useProductDataCaching, useProductsService, userSegmentationData.loading, visitorSegment]);
  return /*#__PURE__*/_jsx(HeadersContext.Provider, {
    value: value,
    children: children
  });
};
export const useHeaders = () => useContext(HeadersContext);
//# sourceMappingURL=headersContext.js.map